import { ContentType } from '@core/models/content-type.models';
import { Folder } from '@core/models/folder.model';
import { VideoData } from '@core/models/entities/video.models';
import { AccessFolder } from '@core/models/folder.model';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export const contentTypeAdapter: EntityAdapter<ContentType> = createEntityAdapter<ContentType>();

export const folderAdapter: EntityAdapter<Folder> = createEntityAdapter<Folder>({
  selectId: folder => folder._id,
});

export const videoAdapter: EntityAdapter<VideoData> = createEntityAdapter<VideoData>({
  selectId: video => video._id!,
});

export interface OnDemandState {
  contentTypesTotalPages: number | null;
  contentTypesTotalItems: number | null;
  contentTypesCurrPage: number | null;
  contentTypes: EntityState<ContentType>;
  accessFolder: AccessFolder | null;
  folderTotalPages: number | null;
  folderTotalItems: number | null;
  folderCurrPage: number | null;
  folders: EntityState<Folder>;
  loadingFolders: boolean;
  videoTotalPages: number | null;
  videoTotalItems: number | null;
  videoCurrPage: number | null;
  videos: EntityState<VideoData>;
  loadingVideos: boolean;
  isShowAll: boolean;
  sliderRange: number;
  error: string | null;
}

export const initialState: OnDemandState = {
  contentTypesTotalPages: null,
  contentTypesTotalItems: null,
  contentTypesCurrPage: null,
  contentTypes: contentTypeAdapter.getInitialState(),
  accessFolder: null,
  folderTotalPages: null,
  folderTotalItems: null,
  folderCurrPage: null,
  folders: folderAdapter.getInitialState(),
  loadingFolders: false,
  videoTotalPages: null,
  videoTotalItems: null,
  videoCurrPage: null,
  videos: videoAdapter.getInitialState(),
  loadingVideos: true,
  isShowAll: false,
  sliderRange: 0,
  error: null,
};
